import { render } from "./AutomationTemplatesLayout.vue?vue&type=template&id=6e4d9414&scoped=true"
import script from "./AutomationTemplatesLayout.vue?vue&type=script&lang=js"
export * from "./AutomationTemplatesLayout.vue?vue&type=script&lang=js"

import "./AutomationTemplatesLayout.vue?vue&type=style&index=0&id=6e4d9414&lang=scss"
import "./AutomationTemplatesLayout.vue?vue&type=style&index=1&id=6e4d9414&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4d9414"]])

export default __exports__